export const SWITCH_VK_DELETE_BACKWARD = "switchvkdeletebackward";
